import React, { Component } from 'react';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import { I18n } from 'react-redux-i18n-lite';
import Dropzone from 'react-dropzone';
import { PropTypes } from 'prop-types';
import * as assetsService from '../../../services/assets/assetsService';
import FileViewBox from '../AssignmentUploadFileBox/FileViewBox';
import { getAcceptedMimetypes } from '../../../services/mimetypes/mimetypesService';
import CircularProgress from '@material-ui/core/CircularProgress';
import { warning } from '../../../actions/messageAlertAction';
import { bindActionCreators } from 'redux';

const styles = {
  linkExample: {
    color: props => props.colors.btnText,
    '&:hover': {
      color: props => props.colors.btnTextHover
    }
  },
  browseButton: {
    backgroundColor: props => props.colors.btnSuccess,
    '&:hover': {
      backgroundColor: props => props.colors.btnSuccessHover
    }
  },
  attachmentRow: {
    marginLeft: '1em',
    marginRight: '1em',
    justifyContent: 'space-between'
  },
  dropZoneCustomCardsScroll: {
    display: 'flex',
    overflowX: 'auto',
    padding: '24px 0'
  },
  dropZoneCustomCard: {
    margin: '0 8px',
    position: 'relative'
  },
  dropZoneCustomImage: {
    alignItems: 'center',
    backgroundColor: '#ccc',
    borderRadius: '20px',
    display: 'flex',
    height: '170px',
    justifyContent: 'center',
    minWidth: '255px',
    overflow: 'hidden',
    width: '255px'
  },
  dropZoneCustomText: {
    color: '#333',
    fontSize: '14px',
    margin: '16px 0 0 0',
    padding: '0 12px',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    webkitBoxOrient: 'vertical',
    webkitLineClamp: '1',
    width: '255px'
  },
  dropZoneCustomButton: {
    alignItems: 'center',
    backgroundColor: 'rgba(24,148,210,0.1)',
    borderRadius: '8px',
    color: '#1894D2',
    height: '170px',
    margin: '0 8px',
    minWidth: '42px',
    width: '42px'
  },
  dropZoneContainer: {
    background: '#f9f9f9',
    margin: '24px 0 0',
    padding: '0 16px'
  },
  removeButton: {
    backgroundColor: '#12ABE3',
    borderRadius: '50%',
    color: '#fff',
    fontSize: '14px',
    height: '32px',
    position: 'absolute',
    right: '-8px',
    top: '-8px',
    width: '32px'
  }
};

class UploadFileContainer extends Component {
  static propTypes = {
    colors: PropTypes.any,
    defaultIcon: PropTypes.any,
    classes: PropTypes.object,
    disableClick: PropTypes.bool,
    maxUploadSize: PropTypes.number,
    defaultFile: PropTypes.array,
    onDeleteFile: PropTypes.func,
    onChangeFile: PropTypes.func,
    showLoader: PropTypes.bool,
    mimetypePolicy: PropTypes.string,
    mimetypes: PropTypes.string,
    messageAlert: PropTypes.func,
    canChange: PropTypes.bool,
    deleteResponseFile: PropTypes.func,
    onDrop: PropTypes.func,
    isEvaluated: PropTypes.bool,
    isInstructor: PropTypes.bool,
    isResponseContainer: PropTypes.bool,
    studentCanUpload: PropTypes.bool,
    maxFilesPerTask: PropTypes.number,
    multiple: PropTypes.bool
  };

  constructor(props) {
    super(props);
  }

  state = {
    files: [],
    fileSizeExceed: false
  };

  onDrop = acceptedFiles => {
    const { maxUploadSize, messageAlert, maxFilesPerTask } = this.props;
    if (acceptedFiles.length < (maxFilesPerTask + 1 || 6)) {
      acceptedFiles.forEach(file => {
        if (
          this.state.files.length < (maxFilesPerTask || 5) &&
          this.state.files.length + acceptedFiles.length < (maxFilesPerTask + 1 || 6)
        ) {
          if (file) {
            const sizeInMegas = assetsService.bytesToMegas(file.size);
            if (sizeInMegas < maxUploadSize) {
              this.setState(prevState => ({
                files: [...prevState.files, file],
                fileSizeExceed: false
              }));
              if (typeof this.props.onDrop === 'function') {
                this.props.onDrop(acceptedFiles);
              } else {
                this.props.onChangeFile(file);
              }
            } else {
              this.setState({ fileSizeExceed: true });
              messageAlert(I18n.t('upload.assetOverMaxSize') + ' ' + maxUploadSize + ' Mb');
            }
          } else {
            messageAlert(I18n.t('upload.unsupported'));
          }
        } else {
          messageAlert(`${I18n.t('upload.tooManyFiles1')} ${maxFilesPerTask || 5} ${I18n.t('upload.tooManyFiles2')}`);
        }
      });
    } else {
      messageAlert(`${I18n.t('upload.tooManyFiles1')} ${maxFilesPerTask || 5} ${I18n.t('upload.tooManyFiles2')}`);
    }
  };

  onDeleteFile = (event, index) => {
    event.stopPropagation();
    const newFiles = [...this.state.files];
    newFiles.splice(index, 1);
    this.setState({
      files: newFiles
    });
    if (typeof this.props.onDeleteFile === 'function') {
      this.props.onDeleteFile(event, index);
    }
  };

  onDeleteFileEvalFile = (event, index) => {
    event.stopPropagation();
    const newFiles = [...this.state.files];
    newFiles.splice(index, 1);
    this.setState({
      files: newFiles
    });
    if (typeof this.props.onDeleteFile === 'function') {
      this.props.onDeleteFile(event, index);
    }
    if (typeof this.props.deleteResponseFile === 'function') {
      this.props.deleteResponseFile(event, index);
    }
  };

  renderDropContainerFile = () => {
    const { disableClick, defaultIcon, classes } = this.props;
    return (
      <div className={`${classes.dropZoneContainer}`}>
        <div className={`${classes.dropZoneCustomCardsScroll}`}>
          {this.state.files.length &&
            this.state.files.map((file, index) => {
              return (
                <div key={index} className={`${classes.dropZoneCustomCard}`}>
                  <img
                    className={`${classes.dropZoneCustomImage}`}
                    alt=""
                    src={file.preview}
                    onError={e => {
                      e.target.onerror = null;
                      e.target.src = defaultIcon;
                    }}
                  />
                  <p className={`${classes.dropZoneCustomText}`}>{file.fileName || file.name}</p>
                  {!disableClick && (
                    <div className="file-buttons">
                      <button className={`${classes.removeButton}`} onClick={e => this.onDeleteFileEvalFile(e, index)}>
                        <i className="close custom-icons-close-button"></i>
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
          <button className={`${classes.dropZoneCustomButton}`}>
            <i className="custom-icons-plus-button"></i>
          </button>
        </div>
      </div>
    );
  };

  //--------------------------------------------------------------------------------------------------------------------
  renderDropContainerNoFile = canUpload => {
    const { defaultIcon, classes } = this.props;

    let labelClassName = !canUpload ? 'text' : 'text no-actions';
    let label = !this.state.file ? 'tasks.dropOrClickToUploadFile' : 'panels.assignment.dragAndDropText';

    if (canUpload) {
      return (
        <div className="drop-container">
          <div>
            <img alt="" src={defaultIcon} />
            <div className={labelClassName}>{I18n.t(label)}</div>
          </div>
        </div>
      );
    }
    return (
      <div className="drop-container">
        <div>
          <img alt="" src={defaultIcon} />
          <div className={labelClassName}>{I18n.t('tasks.noFileUploaded')}</div>
        </div>
      </div>
    );
  };

  render() {
    const {
      disableClick,
      classes,
      defaultFile,
      mimetypes,
      mimetypePolicy,
      canChange,
      isEvaluated,
      isInstructor,
      isResponseContainer,
      studentCanUpload,
      multiple
    } = this.props;

    if (this.props.defaultFile && this.props.defaultFile.length > 0) {
      return (
        <FileViewBox
          classes={classes}
          files={defaultFile}
          onDeleteFileEvalFile={(e, index) => this.onDeleteFileEvalFile(e, index)}
          canChange={canChange}
          showLoader={this.props.showLoader}
          disableClick={disableClick}
          onDrop={files => this.onDrop(files)}
        />
      );
    } else if (!canChange && isEvaluated) {
      return <div className="drop-container">{I18n.t('tasks.noFileUploaded')}</div>;
    } else if (isInstructor || isResponseContainer) {
      return (
        <div id="upload-file-container" className={`${classes.dropZoneContainer}`}>
          {this.props.showLoader ? (
            <div className="drop-container">
              <CircularProgress />
            </div>
          ) : (
            <Dropzone
              multiple={multiple}
              disableClick={disableClick}
              disablePreview={false}
              accept={getAcceptedMimetypes(mimetypes, mimetypePolicy)}
              onDrop={files => this.onDrop(files)}
              style={{ width: '100%' }}
            >
              {this.state.files.length > 0
                ? this.renderDropContainerFile()
                : this.renderDropContainerNoFile(
                    (isInstructor && !isResponseContainer) || (studentCanUpload && !isInstructor)
                  )}
            </Dropzone>
          )}
        </div>
      );
    } else if (this.props.showLoader) {
      return (
        <div className="drop-container">
          <CircularProgress />
        </div>
      );
    }
    return <div className="drop-container">{I18n.t('tasks.noFileUploaded')}</div>;
  }
}

function mapStateToProps(state, ownProps) {
  return {
    multiple: ownProps.multiple !== undefined ? ownProps.multiple : true,
    mimetypePolicy: ownProps.mimetypePolicy || state.account.configuration.mimetypePolicy,
    mimetypes: ownProps.mimetypes || state.account.configuration.mimetypes,
    colors: state.theme.colors,
    maxUploadSize: state.account.configuration.maxUploadSize,
    maxFilesPerTask: ownProps.maxFilesPerTask || state.account.configuration.maxFilesPerTask,
    defaultIcon: state.theme.images.placeholders.attachmentIcon
  };
}

function mapDispatchToProps(dispatch) {
  return {
    messageAlert: bindActionCreators(warning, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(UploadFileContainer));
